export default __webpack_public_path__ + "img/logo-nmo-white.7159c4e8.svg";